

addScrollElementListeners()
addProductAlignmentListeners()
addScrollYListeners()

function addScrollYListeners() {
  window.addEventListener('load', updateScrollY)
  window.addEventListener('scroll', updateScrollY)
  window.addEventListener('resize', updateScrollY)
  updateScrollY()
}

function addProductAlignmentListeners() {
  window.addEventListener('load', alignProducts)
  window.addEventListener('scroll', alignProducts)
  window.addEventListener('resize', alignProducts)
  alignProducts()
}

function addScrollElementListeners() {
  window.addEventListener('load', updateScrollElements)
  window.addEventListener('scroll', updateScrollElements)
  window.addEventListener('resize', updateScrollElements)
  updateScrollElements()
}

function updateScrollY() {
  var root = document.documentElement
  var scrollY = window.scrollY
  root.style.setProperty('--scrollY', scrollY + 'px')
}

function updateScrollElements() {
  var threshold = 20
  var isScrolled = window.scrollY > threshold
  var isBeyondLogoScrollThreshold = window.scrollY > screen.height * 0.45;
  var selectors = ['body', 'header .mobile', 'header .desktop']

  isBeyondLogoScrollThreshold 
    ? document.body.classList.add('isBeyondLogoScrollThreshold')
    : document.body.classList.remove('isBeyondLogoScrollThreshold')


  selectors.forEach(selector => {
    var element = document.querySelector(selector)
    if(!element) return
    isScrolled
      ? element.classList.add('scrolled')
      : element.classList.remove('scrolled')
    isBeyondLogoScrollThreshold 
      ? element.classList.add('isBeyondLogoScrollThreshold')
      : element.classList.remove('isBeyondLogoScrollThreshold')
  })
}

function alignProducts() {
  var productContainers = Array.from(document.querySelectorAll('.products'))
  productContainers.forEach(productContainer => {
    var firstProduct = productContainer.querySelector('.product')
    if(!firstProduct) return
    var width = firstProduct.offsetWidth
    var children = Array.from(productContainer.children)
    var ratio = 466 / 340
    children.forEach(child => {
      var img = child.querySelector('img')
      var height = width * ratio
      if(img) img.style.height = `${height}px`
    })
  })
}

function onSwipe(el, callback){

    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}

    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        e.preventDefault()
    }, false)

    touchsurface.addEventListener('touchmove', function(e){
        e.preventDefault() // prevent scrolling when inside DIV
    }, false)

    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
        e.preventDefault()
    }, false)
}
